<template>
    <v-row class="table-row">
        <v-col :cols="cols" :md="md" class="table-th">{{ label }}</v-col>
        <v-col class="table-td"><slot /></v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        label: String,
        cols: { type: Number, default: 12 },
        md: { type: Number, default: 2 },
    },
};
</script>

<style></style>
